export class StepHandler {
    constructor(onStepChange, validateCallback, nextButtonText, recommendationButtonText, totalSteps) {
        this.currentStep = 1;
        this.modal = document.querySelector('[data-component="service-guide-modal"]');
        this.stepPanels = this.modal.querySelectorAll('.step-panel');
        this.totalSteps = this.stepPanels.length - 1;
        this.prevButton = this.modal.querySelector('.nav-button.prev');
        this.nextButton = this.modal.querySelector('.nav-button.next');
        this.onStepChange = onStepChange;
        this.validateCallback = validateCallback;  // Lagre validateCallback
        this.nextButtonText = nextButtonText;
        this.recommendationButtonText = recommendationButtonText;

        this.navigateNext = this.navigateNext.bind(this);
        this.navigatePrevious = this.navigatePrevious.bind(this);
        
        this.updateStepCounter()
    }

    navigateNext() {
        const nextStep = this.currentStep + 1;
        if (nextStep <= this.totalSteps + 1 && this.validateCallback()) { 
            this.showStep(nextStep);
        }
    }

    navigatePrevious() {
        const prevStep = this.currentStep - 1;
        if (prevStep >= 1) {
            this.showStep(prevStep);
        }
    }

    showStep(stepNumber) {
        const currentPanel = this.stepPanels[this.currentStep - 1];
        const nextPanel = this.stepPanels[stepNumber - 1];

        // Animate out current panel
        currentPanel.classList.add('exit');
        currentPanel.classList.remove('active');

        // Prepare and animate in next panel
        nextPanel.style.display = 'flex';
        requestAnimationFrame(() => {
            nextPanel.classList.add('active');
        });

        // Cleanup after animation
        setTimeout(() => {
            currentPanel.classList.remove('exit');
            currentPanel.style.display = 'none';
        }, 300);

        // Update navigation buttons
        this.updateNavigationButtons(stepNumber);

        // Update current step and counter
        this.currentStep = stepNumber;
        this.updateStepCounter();

        // Set focus to first interactive element
        this.setFocusOnNewStep(nextPanel);

        // Kall onStepChange callback
        if (this.onStepChange) {
            this.onStepChange(stepNumber, this.totalSteps);
        }
    }

    updateNavigationButtons(stepNumber) {
        // Vis/skjul previous button
        this.prevButton.style.display = stepNumber > 1 ? 'flex' : 'none';

        // Vis/skjul og oppdater text på next button
        this.nextButton.style.display = stepNumber < (this.totalSteps + 1) ? 'flex' : 'none';

        // Endre tekst på next button hvis vi er på nest siste steg
        const nextButtonText = this.nextButton.querySelector('span');
        if (stepNumber === this.totalSteps) {
            //hide button, and display 'submit' button
            this.nextButton.style.display = 'none';
            
            const submitButton = this.modal.querySelector('.service-guide-submit');
            submitButton.style.display = 'flex';
            
        } else {
            nextButtonText.textContent = this.nextButtonText;
        }
    }

    updateStepCounter() {
        const currentStepEl = this.modal.querySelector('.current-step');
        const totalStepsEl = this.modal.querySelector('.total-steps');

        if (currentStepEl) currentStepEl.textContent = this.currentStep;
        if (totalStepsEl) totalStepsEl.textContent = this.totalSteps;
    }

    setFocusOnNewStep(panel) {
        setTimeout(() => {
            const firstInput = panel.querySelector('input, button');
            firstInput?.focus();
        }, 300);
    }

    resetToFirstStep() {
        this.stepPanels.forEach((panel, index) => {
            if (index === 0) {
                panel.style.display = 'block';
                panel.classList.add('active');
            } else {
                panel.style.display = 'none';
                panel.classList.remove('active');
            }
        });
        this.currentStep = 1;
        this.updateStepCounter();
        this.updateNavigationButtons(1);
    }

    getCurrentStep() {
        return this.currentStep;
    }

    getTotalSteps() {
        return this.totalSteps;
    }
}